<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Purchase Order Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part Code" id="input-" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-textbox id="fieldset-qty-po" label-cols-lg="12" label="Qty PO" label-for="input-qty-po" size="sm" :model.sync="model.qtyPo" :isRequired="true" :state="validateState('qtyPo')" :errorMessage="getErrorMessage(errorMessage.qtyPo, 'qtyPo')"  />
				<app-input-textbox id="fieldset-price-unit" label-cols-lg="12" label="Price (Rp/Unit)" label-for="input-price-unit" size="sm" :thousandSeparator="true" :model.sync="model.priceUnit" :isRequired="true" :state="validateState('priceUnit')" :errorMessage="getErrorMessage(errorMessage.priceUnit, 'priceUnit')"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-subtotal" label-cols-lg="12" label="Subtotal (Rp)" label-for="input-subtotal" size="sm" :thousandSeparator="true" :model.sync="model.subtotal" :isRequired="true" :state="validateState('subtotal')" :errorMessage="getErrorMessage(errorMessage.subtotal, 'subtotal')"  />
				<app-input-textbox id="fieldset-price-ppn" label-cols-lg="12" label="Ppn" label-for="input-price-ppn" size="sm" :thousandSeparator="true" :model.sync="model.pricePpn" :isRequired="true" :state="validateState('pricePpn')" :errorMessage="getErrorMessage(errorMessage.pricePpn, 'pricePpn')"  />
				<app-input-textbox id="fieldset-amount" label-cols-lg="12" label="Amount" label-for="input-amount" size="sm" :thousandSeparator="true" :model.sync="model.amount" :isRequired="true" :state="validateState('amount')" :errorMessage="getErrorMessage(errorMessage.amount, 'amount')"  />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';
import AppLabel from '@/components/AppLabel';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		partId: {required},
			qtyPo: {required},
			priceUnit: {required},
			subtotal: {required},
			pricePpn: {required},
			amount: {required},
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
				partId: { required : "Part Code is Required."},
				qtyPo: { required : "Qty PO is Required."},
				priceUnit: { required : "Price (Rp/Unit) is Required."},
				subtotal: { required : "Subtotal (Rp) is Required."},
				pricePpn: { required : "Ppn is Required."},
				amount: { required : "Amount is Required."},
			},
			parts : [],
			isBusy: false,
		}
	},
	methods : {
		getPurchaseOrderDetail : async function(id) {
			this.isBusy = true;
			PurchaseOrderDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getParts();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPurchaseOrderDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getParts();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPurchaseOrderDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
